// extracted by mini-css-extract-plugin
export default {"EditorChoice":"EditorChoice_EditorChoice__rXXCC","EditorChoicePrimary":"EditorChoice_EditorChoicePrimary__ui1Nf","starIcon":"EditorChoice_starIcon__cP1Ju"};